import { g as d } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as s, normalizeClass as l, createElementVNode as e } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconAtSign",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(i).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], h = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.5 6A2.5 2.5 0 0 1 6 3.5c.705 0 1.294.333 1.5.5a.5.5 0 1 1 1 0v2.5a1 1 0 0 0 2 0V6a4.5 4.5 0 1 0-1.764 3.573.5.5 0 1 1 .608.794A5.5 5.5 0 1 1 11.5 6v.5a2 2 0 0 1-3.63 1.16A2.5 2.5 0 0 1 3.5 6Zm1 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
  fill: "currentColor"
}, null, -1), f = [
  h
], m = ["id"], p = /* @__PURE__ */ e("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), g = [
  p
];
function v(a, I, n, S, b, t) {
  return s(), r("svg", {
    "aria-label": n.ariaLabel,
    class: l([t.iconSizeClass, "d-icon d-icon--at-sign"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "At Sign",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    e("g", {
      "clip-path": `url(#${a.uniqueID}a)`
    }, f, 8, u),
    e("defs", null, [
      e("clipPath", {
        id: `${a.uniqueID}a`
      }, g, 8, m)
    ])
  ], 10, _);
}
const C = /* @__PURE__ */ o(c, [["render", v]]);
export {
  C as default
};
//# sourceMappingURL=at-sign.js.map
